import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ImageAtoms } from "@vfit/shared/atoms";
import WithHeader from "../WithHeader/WithHeader";
import WithSeeMore from "../WithSeeMore/WithSeeMore";
import { ImageStyled } from "./Image.style";
var Image = function(param) {
    var story = param.story, action = param.action, config = param.config;
    var ref = _sliced_to_array(React.useState(false), 2), loaded = ref[0], setLoaded = ref[1];
    var width = config.width, height = config.height, loader = config.loader, storyStyles = config.storyStyles;
    var imageLoaded = function() {
        setLoaded(true);
        action("play");
    };
    return /*#__PURE__*/ _jsx(WithHeader, {
        story: story,
        children: /*#__PURE__*/ _jsx(WithSeeMore, {
            story: story,
            children: /*#__PURE__*/ _jsxs(ImageStyled, {
                className: "storyContent",
                style: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsx(ImageAtoms, {
                        style: storyStyles || {},
                        image: story.url,
                        nameCard: "image story",
                        onLoad: imageLoaded
                    }),
                    !loaded && /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: width,
                            height: height,
                            position: "absolute",
                            left: 0,
                            top: 0,
                            background: "rgba(0, 0, 0, 0.9)",
                            zIndex: 9,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#ccc"
                        },
                        children: loader || /*#__PURE__*/ _jsx("div", {})
                    })
                ]
            })
        })
    });
};
export var tester = function(story) {
    return {
        condition: !story.content && (!story.type || story.type === "image"),
        priority: 2
    };
};
export default {
    renderer: Image,
    tester: tester
};
